import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";

const GougeComponent = ({ key, speed }) => {
  return (
    <div className="px-10 py-10" key={key}>
      <CircularProgressbarWithChildren
        className="grow rounded-md w-28 h-28 "
        key={key}
        value={speed.toFixed(1)}
        maxValue={150}
        circleRatio={1}
        styles={buildStyles({
          // Rotation of path and trail, in number of turns (0-1)
          rotation: 1 / 2 + 1 / 8,

          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
          strokeLinecap: "butt",

          // Text size
          text: {
            fill: "#0d6aff",
            fontSize: "1px",
          },

          backgroundColor: "#61e8ae",

          // How long animation takes to go from one percentage to another, in seconds
          pathTransitionDuration: 0.4,

          // Can specify path transition in more detail, or remove it entirely
          // pathTransition: 'none',
          // Colors
          pathColor:
            speed < 5
              ? `rgba(230, 25, 25, ${speed.toFixed(2) * 5})`
              : speed < 10
              ? `rgba(209, 186, 8, ${speed.toFixed(2) * 7})`
              : ` rgba(7, 181, 19, ${speed.toFixed(2) * 10})`,
          textColor: "#6193e8",
          trailColor: "#e1e4e6",

          position: "center",
        })}
      >
        <div className="flex flex-col text-lg   text-gray-600">
          <strong>{speed.toFixed(1)} kmh</strong>
        </div>
      </CircularProgressbarWithChildren>
    </div>
  );
};
export default GougeComponent;
